<template>
  <footer class="footer">
    <div class="container-pie">
      <a
        class="enlace"
        href="https://www.mmtseguros.com/aviso-legal"
        target="_blank"
        >Aviso legal</a
      >
      <a
        class="enlace"
        href="https://www.mmtseguros.com/politica-privacidad"
        target="_blank"
        >| Privacidad</a
      >
      <a
        class="enlace"
        href="https://www.mmtseguros.com/politica-cookies"
        target="_blank"
        >| Cookies</a
      >
    </div>
    <p class="contacto">
      Teléfonos de atención de lunes a viernes de 09:00 a 21:00 horas: {{telefAtencionGratuito}} o {{ telefAtencion }}
    </p>
    <div style="height:2.3rem;" />
  </footer>
</template>

<script>
export default {
  computed: {
    telefAtencion() {
      return this.$store.state.telefonoAtencion;
    },

    telefAtencionGratuito() {
      return this.$store.state.telefonoAtencionGratuito;
    }
  }
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: $azulClaroGrisMMT;
  width: 100%;
  font-size: 80%;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.container-pie {
  display: flex;
  justify-content: center;
  width: 100%;
}

.enlacex {
  color: $azulOscuroMMT;
}

a {
  text-decoration: none;
  margin-right: 1rem;
}

.contacto {
  text-align: center;
}
</style>
